import { RBDeviceType } from 'store/railsBuilder/reducer.types';

import { RecordingStatus } from './reducer.types';

export const GET_RECORDINGS_LIMIT = 10000;

export enum RecordingRailType {
    RECORDED_ALL = 'RECORDED_ALL',
    SCHEDULED = 'SCHEDULED_ALL',
    RECORDED_SINGLE = 'RECORDED_SINGLE',
    RECORDED_SERIES = 'RECORDED_SERIES',
}

export enum FetchRecordingsSortType {
    CHRONOLOGICAL_ASC = 'CHRONOLOGICAL_ASC',
    CHRONOLOGICAL_DESC = 'CHRONOLOGICAL_DESC',
    METADATA_ASC = 'METADATA_ASC',
    METADATA_DESC = 'METADATA_DESC',
}

export enum RecordingActionType {
    CANCEL = 'CANCEL',
    DELETE = 'DELETE',
}

export type RecordingsQueryParams = {
    sort?: FetchRecordingsSortType;
    statuses?: RecordingStatus;
    limit?: number;
    page?: number;
    deviceType?: RBDeviceType;
    locale?: string;
    fields?: (string | number)[];
    type?: 'series' | 'individual';
    distinct?: boolean;
    filter?: {
        seriesId?: string;
        eventId?: string;
        contentId?: string;
        channelId?: string;
        'metadata.hu_HU.SeasonNumber'?: number;
    };
};

export type ScheduleRecordingActionPayload = {
    eventId: string;
    isProtected?: boolean;
};

export enum ScheduleSeriesRecordingOptions {
    ALL_EPISODES = 'ALL_EPISODES',
    DONT_RERECORD_DELETED_EPISODES = 'DONT_RERECORD_DELETED_EPISODES',
}

export type ScheduleSeriesRecordingActionPayload = {
    eventId: string;
    seriesId: string;
    seriesType?: string;
    recordingOptions?: ScheduleSeriesRecordingOptions[];
    numberOfEpisodesToKeep?: number;
};

export type ProtectRecordingActionPayload = {
    recordingId: string;
};

export type UnprotectRecordingActionPayload = {
    recordingId: string;
    pinType?: string;
    pin: string;
};

export type DeleteRecordingActionPayload = {
    recordingId: string;
    actionType: RecordingActionType;
    pinType?: string;
    pin?: string;
};

export enum DeleteRecordingOptions {
    DELETE_USER_RECORDINGS = 'DELETE_USER_RECORDINGS',
    UNRECORDED_EPISODES = 'UNRECORDED_EPISODES',
    DELETE_USER_RECORDINGS_BUT_RETAIN_SERIES_LINK = 'DELETE_USER_RECORDINGS_BUT_RETAIN_SERIES_LINK',
}

export type DeleteSeriesRecordingActionPayload = {
    seriesRecordingId: string;
    actionType: RecordingActionType;
    deleteRecordingOption: DeleteRecordingOptions;
    pinType?: string;
    pin?: string;
};
